import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    cart: getCurrentCartState(state).value,
});

export interface CartMessageStyles {
    text?: TypographyPresentationProps;
    textNote?: TypographyPresentationProps;
    wrapper?: InjectableCss;
}

export const cartMessageStyles: CartMessageStyles = {
    wrapper: {
        css: css`
            text-align: left;
            padding: 0 0 4px 0;
            margin-top: 1.5rem;
            @media print {
                display: none;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 0 20px;
                        `,
                        css`
                            padding: 0 20px;
                        `,
                        css`
                            padding: 0px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    text: {
        css: css`
            width: 100%;
            color: #fc3939;
            font-size: 14px;
            font-weight: 500;
        `,
    },
    textNote: {
        css: css`
            color: #fc3939;
            font-weight: bold;
            font-size: 14px;
        `,
    },
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const styles = cartMessageStyles;
const CartMessage = ({ cart }: Props) => {
    if (!cart || cart.cartLines?.length === 0) {
        return null;
    }

    const cartMessageNote = siteMessage("Cart_Message_Note");
    const cartMessage = siteMessage("Cart_Message");

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.textNote}>{translate(cartMessageNote as string)} </Typography>
            <Typography {...styles.text}>{translate(cartMessage as string)}</Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(CartMessage),
    definition: {
        displayName: "Cart Message",
        group: "Common",
    },
};

export default widgetModule;
